var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "plans" },
    [
      _c(
        "v-card",
        { ref: "plans" },
        [
          _c(
            "v-toolbar",
            {
              staticStyle: { "border-radius": "0px" },
              attrs: { fixed: "", flat: "", color: "white" }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { color: "black" } }, [
                    _vm._v("mdi-close")
                  ])
                ],
                1
              ),
              _c("v-img", {
                staticStyle: { margin: "0px auto" },
                attrs: {
                  "max-height": "38",
                  "max-width": "100",
                  src: require("img/wiom_logo.png")
                }
              })
            ],
            1
          ),
          _c(
            "v-card-text",
            {
              staticClass: "plans-content",
              staticStyle: {
                height: "100%",
                "max-height": "auto",
                padding: "0px",
                margin: "0px auto"
              }
            },
            [
              _vm.view == "welcome"
                ? _c("div", { staticClass: "plans-title" }, [
                    _vm._v("Wi-Fi Control")
                  ])
                : _vm._e(),
              _vm.view == "welcome"
                ? _c("v-img", {
                    staticStyle: { margin: "0px auto" },
                    attrs: { width: "207", src: require("img/wificontrol.png") }
                  })
                : _vm._e(),
              _vm.view == "welcome"
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        width: "300px",
                        margin: "0px auto",
                        "margin-top": "25px",
                        color: "#484848",
                        "font-size": "14px"
                      }
                    },
                    [
                      _vm._v(
                        " Internet control now on your phone. Check Data usage, Data limit, Total user and many more… "
                      )
                    ]
                  )
                : _vm._e(),
              _vm.view == "welcome"
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        width: "96px",
                        margin: "0px auto",
                        "margin-top": "24px"
                      }
                    },
                    [
                      _c("v-img", {
                        staticStyle: {
                          display: "inline-block",
                          "margin-right": "7px"
                        },
                        attrs: {
                          width: "16px",
                          src: require("img/icons/network.svg")
                        }
                      }),
                      _c("v-img", {
                        staticStyle: {
                          display: "inline-block",
                          "margin-right": "7px"
                        },
                        attrs: {
                          width: "16px",
                          src: require("img/icons/calendar.svg")
                        }
                      }),
                      _c("v-img", {
                        staticStyle: {
                          display: "inline-block",
                          "margin-right": "7px"
                        },
                        attrs: {
                          width: "16",
                          src: require("img/icons/timer.svg")
                        }
                      }),
                      _c("v-img", {
                        staticStyle: {
                          display: "inline-block",
                          "margin-right": "0px"
                        },
                        attrs: {
                          width: "16",
                          src: require("img/icons/mobile.svg")
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-weight": "bold",
                    "font-size": "20px",
                    color: "#000",
                    "text-align": "center",
                    "margin-top": "40px"
                  }
                },
                [_vm._v("Choose your Plan")]
              ),
              _c("Plan", {
                attrs: { data: _vm.basicPlanData },
                on: {
                  learn: function($event) {
                    return _vm.learn("basic", $event)
                  }
                }
              }),
              _c("Plan", {
                attrs: { data: _vm.proPlanData },
                on: {
                  buy: function($event) {
                    return _vm.buy("magic", $event)
                  },
                  learn: function($event) {
                    return _vm.learn("magic", $event)
                  }
                }
              }),
              _c(
                "v-dialog",
                {
                  attrs: {
                    fullscreen: "",
                    "hide-overlay": "",
                    transition: "dialog-bottom-transition",
                    app: ""
                  },
                  model: {
                    value: _vm.showDetails,
                    callback: function($$v) {
                      _vm.showDetails = $$v
                    },
                    expression: "showDetails"
                  }
                },
                [
                  _c("Details", {
                    attrs: { data: _vm.selectedPlan },
                    on: {
                      close: function($event) {
                        _vm.showDetails = false
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }